import { Component, ChangeDetectionStrategy, Output, EventEmitter, OnInit, Inject, PLATFORM_ID, Input } from '@angular/core';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { FormArrayGroup } from '@shared/components/form-array-group/model/form-array-group';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Select, Store } from '@ngxs/store';
import { SelectModel } from '@shared/components/select/models/select';
import { CustomIcons } from '@shared/models/custom-icons';
import { CatalogItemFieldsVM, CatalogView } from '@shared/models/shared-catalog.state';
import { SharedCatalogState } from '@shared/state/catalog/shared-catalog.state';
import { whitespaceValidator } from '@utils/form-validators';
import { CatalogItemValue } from '../../../../../data/models/catalog';
import { CatalogState } from '../../../../../data/store/catalog/catalog.state';

@Component({
  selector: 'app-incorrect-data-form',
  templateUrl: './incorrect-data-form.component.html',
  styleUrls: ['./incorrect-data-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IncorrectDataFormComponent implements OnInit {
  @Output() public readonly next: EventEmitter<any>;
  @Output() public readonly formInit = new EventEmitter<UntypedFormGroup>();
  @Input() public appealId: number | null;
  @Input() public isImpaired: boolean;
  @Select(CatalogState.selectCatalogItem) public selectCatalogItem$: Observable<CatalogItemValue | undefined>;
  @Select(SharedCatalogState.selectCatalog) public selectCatalog$: Observable<CatalogView>;
  public itemFields: SelectModel[] = [];
  public itemFields$: Observable<CatalogItemFieldsVM[] | undefined>;
  public form: UntypedFormGroup = new UntypedFormGroup({
    nameCatalog: new UntypedFormControl({ value: '', disabled: true }, [Validators.required, whitespaceValidator]),
    problem: new UntypedFormControl('', [Validators.required, whitespaceValidator]),
    rowNumber: new UntypedFormControl({ value: '', disabled: true }, [Validators.required, whitespaceValidator]),
    comment: new UntypedFormControl('', [Validators.required, whitespaceValidator]),
    themeId: new UntypedFormControl(''),
    formType: new UntypedFormControl('incorrect')
  });

  public problemFieldObserver$ = this.form.get('problem')?.valueChanges.pipe(
    tap(val => {
      this.addParams(val);
    })
  );

  public icons = CustomIcons;
  public isDetailedShow = false;

  public attributeGroupData: FormArrayGroup;
  constructor(private store: Store, @Inject(PLATFORM_ID) private platformId: string) {}

  private addParams(val: any): void {
    if (val) {
      this.form.addControl('attributes', new UntypedFormArray([]));
      this.attributeGroupData = {
        label: 'SHARED_COMPONENTS.FORM_ARRAY_GROUP.SELECT_ATTRIBUTES_INCORRECT_VALUES',
        buttonLabel: 'SHARED_COMPONENTS.FORM_ARRAY_GROUP.ADD_ATTRIBUTE',
        mainForm: this.form,
        formArray: this.form.controls.attributes as UntypedFormArray,
        currentFormGroup: () => this.attributeFromGroup(),
        formGroupName: 'attributes',
        placeholderSelectorName: 'SHARED_COMPONENTS.FORM_ARRAY_GROUP.SELECT_ATTRIBUTE',
        formControlSelectorName: 'attribute',
        placeholderValue: 'SHARED_COMPONENTS.FORM_ARRAY_GROUP.ENTER_CORRECT_VALUE_ATTRIBUTE',
        formControlValueName: 'value'
      };
      this.form.get('themeId')?.setValue(1491);
    } else {
      this.form.removeControl('attributes');
      this.form.get('themeId')?.setValue(1490);
    }
    this.formInit.emit(this.form);
  }

  private attributeFromGroup(): UntypedFormGroup {
    return new UntypedFormGroup({
      attribute: new UntypedFormControl(''),
      value: new UntypedFormControl('')
    });
  }

  public ngOnInit(): void {
    this.formInit.emit(this.form);
    this.itemFields$ = this.store.select(SharedCatalogState.fields).pipe(
      tap(fields => {
        this.itemFields =
          fields?.map(f => ({
            value: f.name,
            title: f.name
          })) ?? [];
      })
    );

    this.addParams(this.form.get('themeId')?.value === 1491);
  }
}
